import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
  selector: 'property-parking-section',
  templateUrl: './property-parking-section.component.html',
  styleUrls: ['./property-parking-section.component.scss']
})
export class PropertyParkingSectionComponent extends PropertySectionBase implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();

  @ViewChild('propertyParkingSectionForm')
  propertyParkingSectionForm: NgForm;

  constructor(
    public draftFacade: DraftFacade,
    private changeDetectorRef: ChangeDetectorRef,
    private formHelperService: FormHelperService
  ) {
    super(draftFacade);
  }

  ngOnDestroy(): void {
    super.onDestroy();
    this._destroyed$.next();
  }

  ngOnInit(): void {
    super.onInit(() => {
        this.changeDetectorRef.markForCheck();
    });
  }

  isValid(): boolean {
    this.formHelperService.validate(this.propertyParkingSectionForm);
    return this.propertyParkingSectionForm.form.valid;
  }

  dirty(): boolean {
    return this.propertyParkingSectionForm.form.dirty;
  }
}